import { useNavigate } from "react-router-dom";

export default function NotFount() {
  const navigate = useNavigate();
  return (
    <div className="not-found-wrapper">
      <div className="not-found-image">
        <img src={"/images/404.png"} alt={""} />
      </div>
      <div className="bottom-content-not-found">
        <div className="not-found-title">این تونل به معدن طلا نمی‌رسد!</div>
        <div className="not-found-subtitle">
          این صفحه حذف شده، برای پیداکردن طلا به صفحه معامله سر بزنید.
        </div>
        <button
          className="form-input-button-custom"
          onClick={() => navigate("/trade-market")}
        >
          صفحه معامله
        </button>
      </div>
    </div>
  );
}
